/**
 * Stores build information. The string literals are replaces at compile time by `set_version.js`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "nightly 2023-03-04",
    versionChannel: "nightly",
    buildDate: "2023-03-04T00:19:50.818Z",
    commitHash: "1ef539e31bc58569d10abda9a70ab9c0d5c03349",
};
